document.addEventListener("DOMContentLoaded", () => {
  const getScreenWidth = () => {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  };

  function isEnteringBottomOfViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top > 0
    );
  }

  function isBelowViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top > (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function toggleClassOnVisibility() {
    const elements = document.querySelectorAll(".entry_anim");
    elements.forEach((element) => {
      if (isEnteringBottomOfViewport(element)) {
        element.classList.add("active");
      } else if (isBelowViewport(element)) {
        element.classList.remove("active");
      }
    });
  }

  let windowWidth = getScreenWidth();
  window.addEventListener("resize", () => {
    windowWidth = getScreenWidth();
  });

  if (windowWidth > 767) {
    window.addEventListener("scroll", toggleClassOnVisibility);
    window.addEventListener("resize", toggleClassOnVisibility);
    document.addEventListener("DOMContentLoaded", toggleClassOnVisibility);
  }
});
